module.exports = __webpack_public_path__ + "img/pr-9.51a4bc18.png";